import {
  CouponType,
  OnSiteLocationType,
  OrderMethod,
  PaymentMethod,
  RefundReason,
} from '../../../../../../services/exports/Constants';

export default {
  title: 'Tilauksen tiedot',
  sections: {
    driver_info: 'Kuljettajan tiedot',
    order_info: 'Tilauksen tiedot',
    price_info: 'Hintatiedot',
    adjustments: 'Muutokset',
  },
  order_methods: {
    [OrderMethod.Pickup]: 'Nouto',
    [OrderMethod.Delivery]: 'Toimitus',
    [OnSiteLocationType.RoomService]: 'Huonepalvelu',
    [OnSiteLocationType.TableService]: 'Pöytäpalvelu',
  },
  room_service_location_types: {
    [OnSiteLocationType.RoomService]: {
      details_label: 'Huoneen numero',
    },
    [OnSiteLocationType.TableService]: {
      details_label: 'Pöydän numero',
    },
  },
  labels: {
    wolt_support: 'Woltin tukinumero: {{phone_number}}',
    wolt_support_text:
      'Jos sinulla on kysyttävää tilauksesta, kuljettajasta tai ongelmista, soita Woltille. On tärkeää mainita, että kyseessä on <strong>Wolt Drive</strong> -tilaus',
    dummy_order: 'Testitilaus',
    asap: 'Mahdollisimman pian',
    driver_name: 'Kuljettajan nimi',
    driver_phone_number: 'Kuljettajan puhelin',
    pin_code: 'PIN',
    dropoff_pin_code: 'Toimituksen PIN',
    original: 'Alkuperäinen',
    delivery_fee: 'Toimitusmaksu',
    tip: 'Tippi',
    service_fee: 'Verkkokäsittely',
    payment_method_upcharge_fee: {
      [PaymentMethod.Paypal]: 'PayPal-maksu',
    },
    promo_applied: {
      default: 'Alennus käytetty',
      [CouponType.Reward]: 'Kanta-asiakaspisteitä käytetty',
      [CouponType.Cashback]: 'Kanta-asiakaspisteitä käytetty',
      [CouponType.PromoCode]: 'Alennus käytetty',
      [CouponType.GiftCard]: 'Lahjakortti käytetty',
    },
    tax: 'Verot',
    total: 'Yhteensä',
    online_payment: 'Asiakas on jo maksanut {{provider}}-sovelluksessa',
    cash_payment: 'Maksu paikan päällä',
    invoice_payment: 'Maksu laskulla',
    old_order: 'Tämä tilaus on toimitettu onnistuneesti',
    pickup_time: 'Noutoaika',
    pickup_asap: 'Asiakas on pyytänyt mahdollisimman nopeaa noutoa.',
    points_used: 'Tähän tilaukseen sisältyy kanta-asiakkaan lunastama kanta-asiakaspalkinto',
    order_note: 'Tilaushuomautus:',
    today: 'tänään',
  },
  schedule: {
    header: 'Ajoitettu {{date}}, {{time}}',
    text: 'Muistutamme, kun on aika aloittaa tilauksen valmistelu',
  },
  adjustment_reasons: {
    [RefundReason.RequestedByCustomer]: 'Asiakkaan pyynnöstä',
    [RefundReason.Reclamation]: 'Reklamaatio',
    [RefundReason.CommunicationError]: 'Viestintävirhe',
    [RefundReason.Other]: 'Muu',
    [RefundReason.Dispute]: 'Asiakkaan reklamaatio',
    dispute_win: 'Reklamaatio voitettu',
    null: '',
  },
  toasts: {
    print_one: 'Tulostetaan {{count}} kuitti: Tilaus <strong>#{{orderNumber}}</strong>...',
    print_other: 'Tulostetaan {{count}} kuittia: Tilaus <strong>#{{orderNumber}}</strong>...',
    refund_successful: 'Hyvitys onnistui: Tilaus <strong>#{{orderNumber}}</strong>...',
  },
  buttons: {
    print: 'Tulosta',
    confirm: 'Vahvista',
    reject: 'Hylkää',
    refund: 'Hyvitä',
  },
};
